import React, { FunctionComponent, useState, useEffect } from "react"
import { handleCollectionCount } from "../../store/data/actions"
import { iNavigation } from "../../api/NavigationMenus"
import { Link } from "react-router-dom"
import DotLoader from "../../components/Loader/DotLoader"
import s from "./Home.less"

interface iWidgetProps {
  item: iNavigation
}

const Widget: FunctionComponent<iWidgetProps> = ({ item }) => {
  const [loading, setLoading] = useState(true)
  const [count, setCount] = useState(0)

  useEffect(() => {
    handleCollectionCount(item.collection).then((result) => {
      setCount(result)
      setLoading(false)
    })
  }, [])

  return (
    <div className={`${s.col4} ${s.widgetColor}`}>
      <div className={s.widget}>
        <div className={s.widgetContent}>
          <Link to={item.path}>
            <div className={s.contentWrap}>
              <h2>{item.name}</h2>
              <h3>{loading ? <DotLoader /> : count}</h3>
            </div>
          </Link>
          {item.pathNew && (
            <div className={s.createNew}>
              <Link to={item.pathNew}>Create New</Link>
            </div>
          )}
        </div>
        <div className={s.icon}>
          <i className={item.icon}></i>
        </div>
      </div>
    </div>
  )
}

export default Widget
